import { getUsersInWorkspace, searchUsersInWorkspace } from 'APP/model/workspace/workspaceModel';
import { WorkspaceRole } from 'APP/model/workspace/workspaceModel.types';
import { User } from 'APP/store/Users/User/User';
import Entities from 'STORE';

const MEMBERS_LIMIT = 20;

export interface IWorkspaceUser {
  user: User;
  role: WorkspaceRole;
}

export async function getWorkspaceUsers({
  searchText,
  cursor,
  limit = MEMBERS_LIMIT,
}: {
  searchText?: string;
  cursor?: string;
  limit?: number;
}): Promise<{ users: IWorkspaceUser[]; cursor?: string }> {
  const response = searchText
    ? await searchUsersInWorkspace({ query: searchText, cursor, limit })
    : await getUsersInWorkspace({ cursor, limit });

  const users: User[] = [];

  const workspaceUsers = response.users.map((workspaceUser) => {
    const existUser = Entities.usersStore.getUserById(workspaceUser.user.id);

    const user = existUser || new User(Entities.usersStore, workspaceUser.user);

    if (!existUser) {
      users.push(user);
    }

    return {
      role: workspaceUser.role,
      user,
    };
  });

  Entities.usersStore.add(users);

  return {
    users: workspaceUsers,
    cursor: response.cursor,
  };
}
